import { styled } from '@fluentui/react';
import { InfoButtonBase } from './InfoButton.base';
import { getStyles } from './InfoButton.styles';
import { IInfoButtonProps, IInfoButtonStyleProps, IInfoButtonStyles } from './InfoButton.types';

// Use Fabric Base guidelines since this might be contributed back to Fabric.
export const InfoButton = styled<IInfoButtonProps, IInfoButtonStyleProps, IInfoButtonStyles>(InfoButtonBase, getStyles, undefined, {
  scope: 'InfoButton',
});
